const TRANSLATION_TEXT = 'text';

export class Translation {
  constructor(rawData = {}) {
    this.rawData = {...rawData};
  }

  getText() {
    return this.rawData[TRANSLATION_TEXT] || '';
  }
}

export default {Translation};
